import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'
import { metrics } from 'component-library/__styling/settings'

export const StyledSourceLogo = styled('img')({
    marginRight: calcRem(8),
    width: calcRem(70),
})

export const StyledSourceFallback = styled('span')({
    whiteSpace: 'nowrap',
    padding: calcRem(metrics.sevennews.margins.sm),
})
